<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>各校教师布置作业详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持作业标题，班级名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--活跃大屏具体使用详情-->
                <div class="table-wrapper-data">
                    <Table :columns="teaAssignHwColumn" :data="teaAssignHwList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import dateSelect from "../../../../components/dateSelect.vue";
    import {getHomeWorkList} from "../../../../service/api.js";

    export default {
        name: "homework-details",
        data () {
            return {
                schoolId: this.$route.query.schoolId,
                schoolName: this.$route.query.schoolName,
                startTime: this.$route.query.selfStartDate,//上一个页面选择的开始时间
                endTime: this.$route.query.selfEndDate,//上一个页面选择的结束时间
                selfStartDate: this.$route.query.selfStartDate,
                selfEndDate: this.$route.query.selfEndDate,
                parentalStartDate: this.$route.query.parentalStartDate,//主页面选择的结束时间
                parentalEndDate: this.$route.query.parentalEndDate,//主页面选择的结束时间
                teaId: this.$route.query.teaId,
                routerResource: this.$route.query.routerResource,
                keyWord: "",
                page: 1,
                limit: 10,
                total:0,
                pageCount: 0,//页数
                teaAssignHwColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        width:150,
                        align: "center",
                    },
                    {
                        title: "教师名称",
                        key: "display_name",
                        width:100,
                        align: "center",
                    },
                    {
                        title: "学科",
                        key: "bank_name",
                        width:200,
                        align: "center",
                    },
                    {
                        title: "班级名称",
                        width:200,
                        key: "object_names",
                        align: "center",
                    },
                    {
                        title: "作业标题",
                        key: "title",
                        align: "center",
                    },
                    {
                        title: "作业类型",
                        key: "hwTypeCode",
                        width:200,
                        align: "center",
                    },
                    {
                        title: "创建时间",
                        key: "create_time",
                        align: "center",
                    }
                ],
                teaAssignHwList: [],//数据集合
            }
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             *获取活跃大屏具体使用详情数据
             */
            async getHomeWorkList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startTime,
                    endTime: _this.endTime,
                    teaId: _this.teaId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getHomeWorkList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.teaAssignHwList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 翻页
             */
            handleCurrentChange(val){
                this.page = val;
                this.getHomeWorkList();
            },
            /**
             * 搜索
             */
            handleSearch(){
                this.page = 1;
                this.total=0;
                this.getHomeWorkList();
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                if(this.routerResource==-1){
                    this.$router.push({
                        name: "boardMain",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            startDate: this.selfStartDate,
                            endDate: this.selfEndDate,
                        }
                    });
                }else{
                    this.$router.push({
                        name: "assHomeworkTea",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            parentalStartDate: this.selfStartDate,//二级页面选择的开始时间
                            parentalEndDate: this.selfEndDate,//二级页面选择的结束时间
                            curSeleMainStartDate: this.parentalStartDate,//一级页面选择的开始时间
                            curSeleMainEndDate: this.parentalEndDate,//一级页面选择的结束时间
                            type:1
                        }
                    });
                }

            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page=1;
                this.startTime = startDate;
                this.endTime = endDate;
                this.getHomeWorkList();
            }
        },
        mounted () {
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            //获取班级安装大屏详情数据
            this.getHomeWorkList();
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.startTime, this.endTime);
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }
        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }
        .ivu-row {
            margin-top: 0 !important;
        }
        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
